import { Box, Text } from '@wix/design-system';
import { PurchaseOffering } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { GiftIcon } from '../../GiftIcon';
import { useCurrentModule } from '../../ModuleProvider';
import { FREE_DOMAIN_CHECKOUT_SUMMARY_ONE_YEAR_KEY } from '../../../utils/consts';
import s from '../Checkout.scss';
export const CheckoutFreeDomainInCheckout = () => {
  var _selectedCycle$cycleD, _selectedCycle$cycleD2;
  const module = useCurrentModule();
  const selectedCycle = module.SDK.PackagePickerStore.useSelectedCycle();
  const {
    t
  } = module.internals.useTranslations();
  const {
    data: currentProductStatus
  } = module.SDK.switchApiClient.hooks.useGetCurrentProductStatus({});
  const isYearlyCycle = (selectedCycle == null || (_selectedCycle$cycleD = selectedCycle.cycleDuration) == null ? void 0 : _selectedCycle$cycleD.unit) === PurchaseOffering.DurationUnit.YEAR;
  const yearCount = (selectedCycle == null || (_selectedCycle$cycleD2 = selectedCycle.cycleDuration) == null ? void 0 : _selectedCycle$cycleD2.count) ?? 0;
  if ((currentProductStatus == null ? void 0 : currentProductStatus.status) !== 'noCurrentProduct' || !isYearlyCycle || yearCount <= 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: "checkout-free-domain-in-checkout",
    margin: "SP3 0 SP2 0",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    gap: "4px",
    className: s.checkoutFreeDomainRow,
    width: "100%"
  }, /*#__PURE__*/React.createElement(GiftIcon, null), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal",
    className: s.checkoutFreeDomainLabel
  }, /*#__PURE__*/React.createElement("strong", null, t(FREE_DOMAIN_CHECKOUT_SUMMARY_ONE_YEAR_KEY)))));
};
//# sourceMappingURL=CheckoutFreeDomainInCheckout.js.map